<template>
  <div>
    <div v-if="groupOrderLine[0].status == 0">
      <p v-if="order.status == 11">待接单</p>
      <p v-if="order.status == 12">待支付</p>
      <p v-if="order.status == 13">待下单</p>
      <p v-if="order.status == 14">下单中</p>
      <p v-if="order.status == 15">待发货</p>
    </div>
    <div class="packStatus">
      <p v-if="groupOrderLine[0].status == 1">待发货</p>
      <p v-if="groupOrderLine[0].status == 4 && !isSingle">已发货</p>
      <p v-if="groupOrderLine[0].status == 4 && isSingle">已发货</p>
      <p v-if="groupOrderLine[0].status == 2">已完成</p>
      <p v-if="groupOrderLine[0].status == 5">转运中</p>
      <p v-if="groupOrderLine[0].status == 6">派送中</p>
    </div>
    <p v-if="order.status == 30">已取消</p>
    <div v-if="['30'].indexOf(order.status) > -1" class="notMobile">
      <p class="cancel-date">{{order.cancel_time}}</p>
    </div>

    <!--货品取消-->
    <div v-if="groupOrderLine[0].status == 3 && order.status != 30">
      <p>已取消</p>
      <div class="notMobile">
        <p class="cancel-date">{{groupOrderLine[0].cancel_time}}</p>
      </div>
    </div>
    <div v-if="groupOrderLine[0].status == 7 && order.status != 30">
      <p>发货后已取消</p>
      <div class="notMobile">
        <p class="cancel-date">{{groupOrderLine[0].cancel_time}}</p>
      </div>
    </div>
    <!--<div v-if="order.business_order_no && !trackTask" class="order-code notMobile">
      <p style="margin-bottom: 10px;">任务号</p>
      <a style="color:#333;">{{order.business_order_no}}</a>
    </div>-->
    <div v-for="(s,index) in groupOrderLine[0].AWB_list" :key="index">
      <div v-if="['2', '4','5','6'].indexOf(groupOrderLine[0].status+'') >-1" class="order-code notMobile" style="margin-top:10px;">
        <p style="margin-bottom: 10px;">{{s.express}}</p>
        <a style="text-decoration: underline;" :href="s.ship_url" target="blank">{{s.AWB}}</a>
      </div>
    </div>
    <div v-if="groupOrderLine[0].status==4 && groupOrderLine[0].AWB_list.length==0">
      <div class="order-code notMobile" style="margin-top:10px;">
        <p style="margin-bottom: 10px;">商家物流</p>
        <p>暂无</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../services/api.js'
let _ = require('lodash')
export default {
  name: 'OrderState',
  props: ['order', 'groupOrderLine' , 'packageId', 'isSingle','mobiletype','trackTask','showPackstatus'],
  data () {
    return {
      shipping_info:[],
      title: '',
      dropdownName:null,
    }
  },
  created() {
    if(this.groupOrderLine[0].transport_status == '1' || this.groupOrderLine[0].transport_status == '0'){
      this.dropdownName = '待预报'
    }else if(this.groupOrderLine[0].transport_status == '2'){
      this.dropdownName = '已预报'
    }else if(this.groupOrderLine[0].transport_status == '3'){
      this.dropdownName = '无需预报'
    }
  },
  methods: {
    
    async handleCommand (command){
      if(command == '1'){
        this.dropdownName = '待预报'
      }else if(command == '2'){
        this.dropdownName = '已预报'
      }else{
        this.dropdownName = '无需预报'
      }
      let good_id = []
      _.each(this.groupOrderLine,item => {
        good_id.push(item.id)
      })
      console.log(command)
      let data = {
        order_id:this.order.id,
        good_id:good_id,
        status:command,
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'change_transport_status',
        data:data,
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
      }
      else{
        alert('该账号没有权限进行此操作')
      }
    },
    getshippinginfo () {
      this.shipping_info=[];
      this.groupOrderLine[0].AWB_list.forEach(element => {
        _.each(this.order.shipping_info,item => {
          if(element == item.AWB){
            let obj={};           
              obj.shipping_number = item.AWB
              obj.title = item.express
            
            obj.shipping_url=item.ship_url;
            this.shipping_info.push(obj)
          }
        })
      });
    }
  },
  /*watch: {
    groupOrderLine (newShipping) {
      this.getshippinginfo()
    }
  }*/

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .order-state {
    float: right;
    text-align: right;
    p {
      color: #888888;
      margin-bottom: 20px;
    }

    .order-code {
      p {
        margin-bottom: 5px;
      }
    }
    .cancel-date {
      color: #333;
    }
  }

  .packStatus{
    position: relative;
    p{
      display: inline-block;
      margin-right: 5px;
    }
  }


  @media screen and (max-width: 1024px) {
    .notMobile {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/merchantOrders/list/OrderState.vue